import { DateStep, humanReadableDateStep } from '@frontend/common';
import React from 'react';

import SelectInputV2, { SelectInputV2Props } from '../select/select-input-v2/select-input-v2.component';

const ID = 'period-type-select';
export const PeriodSelect = (props: Omit<SelectInputV2Props<DateStep>, 'options'>) => {
    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            label='Period'
            options={Object.entries(DateStep).map(([key, value]) => ({ value: value, label: key.replace(/_/g, ' '), display: humanReadableDateStep(value) }))}
            value={props.value}
            onSelect={props.onSelect}
            isClearable={props.isClearable}
        />
    );
};
